import { query } from '@kurtosys/ksys-app-template';
import {
    IQueryContext,
    IQueryKeyValue,
    IExecutionOptions,
} from '@kurtosys/ksys-api-client/dist/models/commonTypes';

export default function getQueryResults(
    queryContext: IQueryContext,
    queries: IQueryKeyValue,
    culture?: string,
    inputs?: object
) {
    if (queryContext && queries) {
        const executionOptions: IExecutionOptions = {
            culture,
            inputs,
            fallbackCulture: 'en-GB',
            context: queryContext,
        };
        const result = query.Query.convertQueryMime(
            JSON.parse(JSON.stringify(queries)),
            executionOptions
        );
        return result;
    }
    return {};
}



// WEBPACK FOOTER //
// ./src/utils/query/getQueryResults.ts